import { selectUser } from '@glass/web/modules/auth';

import { selectAuthProps } from '@glass/shared/modules/authForm';

const selectUserResumeContactEmail = (state) =>
  selectUser(state)?.email || selectAuthProps(state)?.email;

export default selectUserResumeContactEmail;
